import React, { useState, useMemo } from 'react';
import FlexibleModal from 'react-modal-touch';
import MitreAttackDoc from './MitreAttackDoc';
import Loading from '../DocList/Loading';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fal } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

library.add(fal);

const ModalTrigger = ({ doc, preDoc, profilePrimary }) => {
  const [isOpen, setIsOpen] = useState(false);
  const close = () => {
    setIsOpen(false);
  };

  return (
    <div>
      <button
        onClick={() => {
          setIsOpen(true);
        }}
      >
        --View
      </button>
      <FlexibleModal
        className='bulldog-app'
        isOpen={isOpen}
        onRequestClose={close}
        isDraggable
        initWidth={800}
        initHeight='auto'
      >
        <button className='modal-close' onClick={() => close()}>
          <FontAwesomeIcon icon={['fal', 'times']} />
        </button>
        <MitreAttackDoc
          doc={doc}
          preDoc={preDoc}
          profilePrimary={profilePrimary}
        />
      </FlexibleModal>
    </div>
  );
};

export default ModalTrigger;
